import { httpClient } from '@/infrastructure/api/httpClient';
import type { AuthRepository, AuthResponse } from '@/domain/port/AuthRepository';
import type { User } from '@/domain/model/User';

export class AuthApiAdapter implements AuthRepository {
  async login(email: string, password: string): Promise<AuthResponse> {
    const response = await httpClient.post<AuthResponse>('/auth/login', { email, password });
    return response.data;
  }

  async signup(name: string, email: string, password: string): Promise<AuthResponse> {
    const response = await httpClient.post<AuthResponse>('/auth/signup', { name, email, password });
    return response.data;
  }

  async getCurrentUser(): Promise<User> {
    const response = await httpClient.get<User>('/auth/me');
    return response.data;
  }
}
